import { isProviderSeatRole, ProviderWorkPosition } from '@constants/Providers'

/** Block provider seat roles when at limit, except for staff already on a seat. */
export const shouldRestrictProviderSeatRoles = (
  atProviderSeatLimit: boolean,
  originalWorkRole: string | undefined,
): boolean => atProviderSeatLimit && !isProviderSeatRole(originalWorkRole)

export const isProviderSeatRoleOptionDisabled = (
  atProviderSeatLimit: boolean,
  originalWorkRole: string | undefined,
  optionRole: string,
): boolean =>
  shouldRestrictProviderSeatRoles(atProviderSeatLimit, originalWorkRole) &&
  isProviderSeatRole(optionRole)

/**
 * Roles shown when assigning treating providers on treatment plan procedures.
 * Includes clinician "seat" roles plus hygienists (and common role label aliases).
 */
export const isTreatmentPlanProcedureProviderRole = (
  workRole: string | undefined,
): boolean => {
  if (!workRole) return false
  if (isProviderSeatRole(workRole)) return true
  const n = workRole.trim().toLowerCase()
  const hygienistLabels = new Set([
    ProviderWorkPosition.DENTAL_HYGIENIST.toLowerCase(),
    'hygienist',
  ])
  return hygienistLabels.has(n)
}
